import { storableError } from '../../util/errors';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';

// ================ Action types ================ //

export const FETCH_BLOCKED_USERS_REQUEST = 'app/BlockedUsersPage/FETCH_BLOCKED_USERS_REQUEST';
export const FETCH_BLOCKED_USERS_SUCCESS = 'app/BlockedUsersPage/FETCH_BLOCKED_USERS_SUCCESS';
export const FETCH_BLOCKED_USERS_ERROR = 'app/BlockedUsersPage/FETCH_BLOCKED_USERS_ERROR';

export const UNBLOCK_USER_REQUEST = 'app/BlockedUsersPage/UNBLOCK_USER_REQUEST';
export const UNBLOCK_USER_SUCCESS = 'app/BlockedUsersPage/UNBLOCK_USER_SUCCESS';
export const UNBLOCK_USER_ERROR = 'app/BlockedUsersPage/UNBLOCK_USER_ERROR';

// ================ Reducer ================ //

const initialState = {
    fetchBlockedUsersInProgress: false,
    fetchBlockedUsersError: null,
    blockedUsersData: [],

    unblockUserInProgress: false,
    unblockUserError: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case FETCH_BLOCKED_USERS_REQUEST:
            return { ...state, fetchBlockedUsersInProgress: true, fetchBlockedUsersError: null };
        case FETCH_BLOCKED_USERS_SUCCESS:
            return { ...state, fetchBlockedUsersInProgress: false, blockedUsersData: payload };
        case FETCH_BLOCKED_USERS_ERROR:
            return { ...state, fetchBlockedUsersInProgress: false, fetchBlockedUsersError: payload };

        case UNBLOCK_USER_REQUEST:
            return { ...state, unblockUserInProgress: true, unblockUserError: null };
        case UNBLOCK_USER_SUCCESS:
            return { ...state, unblockUserInProgress: false };
        case UNBLOCK_USER_ERROR:
            return { ...state, unblockUserInProgress: false, unblockUserError: payload };

        default:
            return state;
    }
}

// ================ Action creators ================ //

export const fetchBlockedUsersRequest = () => ({ type: FETCH_BLOCKED_USERS_REQUEST });
export const fetchBlockedUsersSuccess = users => ({ type: FETCH_BLOCKED_USERS_SUCCESS, payload: users });
export const fetchBlockedUsersError = e => ({ type: FETCH_BLOCKED_USERS_ERROR, error: true, payload: e });

export const unblockUserRequest = () => ({ type: UNBLOCK_USER_REQUEST });
export const unblockUserSuccess = () => ({ type: UNBLOCK_USER_SUCCESS });
export const unblockUserError = e => ({ type: UNBLOCK_USER_ERROR, error: true, payload: e });

// ================ Thunks ================ //

export const fetchBlockedUsers = () => (dispatch, getState, sdk) => {
    dispatch(fetchBlockedUsersRequest());

    const currentUser = getState().user.currentUser;
    if (!currentUser) {
        return dispatch(fetchBlockedUsersError(new Error('CurrentUser not found')));
    }

    const blockedUsersIds = currentUser.attributes?.profile?.privateData?.blockedUsers || [];
    if (blockedUsersIds.length === 0) {
        return dispatch(fetchBlockedUsersSuccess([]));
    }

    // Fetch each user's details
    const fetchPromises = blockedUsersIds.map(id =>
        sdk.users.show({ id, include: ['profileImage'] }).then(response => response.data.data)
    );

    return Promise.all(fetchPromises)
        .then(users => {
            dispatch(fetchBlockedUsersSuccess(users));
        })
        .catch(e => {
            dispatch(fetchBlockedUsersError(storableError(e)));
        });
};

export const unblockUser = userId => (dispatch, getState, sdk) => {
    dispatch(unblockUserRequest());

    const currentUser = getState().user.currentUser;
    if (!currentUser) {
        return dispatch(unblockUserError(new Error('CurrentUser not found')));
    }

    const blockedUsersIds = currentUser.attributes?.profile?.privateData?.blockedUsers || [];
    const updatedBlockedUsers = blockedUsersIds.filter(id => id !== userId);

    return sdk.currentUser
        .updateProfile({
            privateData: {
                blockedUsers: updatedBlockedUsers,
            },
        }, {
            expand: true,
            include: ['profileImage'],
        })
        .then(response => {
            dispatch(unblockUserSuccess());
            const entities = denormalisedResponseEntities(response);
            if (entities.length === 1) {
                dispatch(currentUserShowSuccess(entities[0]));
            }
            // Re-fetch the blocked users list to update UI
            dispatch(fetchBlockedUsers());
        })
        .catch(e => {
            dispatch(unblockUserError(storableError(e)));
        });
};

export const loadData = () => (dispatch) => {
    return dispatch(fetchBlockedUsers());
};
